import React from 'react';
import { useStyles } from './ForgotPassword.styles';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import theme from '../../styles/theme';
import AppButton from '../../components/designe/app-button/AppButton';
import { Paths } from '../../shared/paths';
import { successToastMessage } from '../../components/layout/toast-root/toast';
import { useForgotPasswordPage } from './useForgotPasswordPage';
import AppFormTextField from '../../components/designe/app-form-text-field';

export default function ForgotPassword() {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  // const [emailSent, setEmailSent] = useState<boolean>(false);
  const navigate = useNavigate();
  const { formik } = useForgotPasswordPage(t, () => {
    successToastMessage(t('forgotPassword.emailSentMessage'));
    navigate(Paths.signIn);
  });

  return (
    <div className={classes.forgotPasswordWrapper}>
      <div className={classes.forgotPasswordContentWrapper}>
        {/*{emailSent && <div className={classes.sentIconWrapper}>*/}
        {/*  <MarkEmailIcon/>*/}
        {/*  <Typography variant={"body1"} align={'center'}>*/}
        {/*		{t("forgotPassword.emailSentMessage")}*/}
        {/*  </Typography>*/}
        {/*</div>*/}
        {/*}*/}

        {/*{!emailSent && */}
        <form
          onSubmit={formik.handleSubmit}
          className={classes.forgotPasswordForm}>
          <AppFormTextField
            label={t('common.email')}
            fullWidth
            name="email"
            formik={formik}
          />
          <AppButton
            type="submit"
            fullWidth
            className={classes.forgotPasswordSubmitButton}>
            {t('forgotPassword.sendEmail')}
          </AppButton>
        </form>
        {/*}*/}

        <div className={classes.backToLogin}>
          <Link className={classes.backToLoginButton} to={Paths.signIn}>
            {t('signIn.signIn')}
          </Link>
        </div>
      </div>
    </div>
  );
}
